module.exports = __webpack_public_path__ + "img/d22.7512b173.png";